export default "__VITE_ASSET__DsK1evYh__"